import React from 'react';
import dateFormat from 'dateformat';

import * as S from './RecentSearchUI.styles';
import {sendEvarData} from '@ibibo/analytics';


const RecentSearchUI = ({
  updateQueryCaller,
  onSearch,
  goHomeSearchesList,
  addDays,
  defaultCheckinOffset,
  defaultCheckoutOffset,
  eventMiddlewareForFE,
}) => {

  return (
    <S.RecentSearchOuterWrapper>
      <S.RecentSearchInnerWrap>

        <S.RecentSearchHeadText>Recent Searches: </S.RecentSearchHeadText>

        <S.RecentSearchListWrap>
          {goHomeSearchesList.map((item, index) => {
            let checkinDate = new Date(item.checkin.date);
            let checkoutDate = new Date(item.checkout.date);
            let currentDate = new Date();
            checkinDate.setHours(0, 0, 0, 0);
            checkoutDate.setHours(0, 0, 0, 0);
            const checkinDateForUI =
              checkinDate.getTime() < currentDate.getTime() ||
              checkinDate.getTime() > checkoutDate.getTime()
                ? addDays(new Date(), defaultCheckinOffset)
                : checkinDate;
            const checkoutDateForUI =
              checkoutDate.getTime() < currentDate.getTime() ||
              checkoutDate.getTime() < checkinDate.getTime()
                ? addDays(new Date(), defaultCheckoutOffset)
                : checkoutDate;

            return (
              <li key={`recentsearch${index}`} onClick={eventMiddlewareForFE({
                  onClick: () => {
                    updateQueryCaller({
                      checkin: {date: new Date(checkinDateForUI)},
                      checkout: {date: new Date(checkoutDateForUI)},
                      roomString: item?.roomString,
                      destination: item?.destination,
                      partner: item?.partner,
                    });
                    onSearch();
                    sendEvarData({
                      prop71: `hotel_widget_recent_${index+1}_clicked`,
                      prop54: `hotel_widget_recent_${index+1}_clicked`,
                    }, true)
                    // homePageClicksGAHandler(index);
                  },
                })}>
                <p>{item.destination.n}</p>
                <span>{`${dateFormat(checkinDateForUI, 'dd mmm yy')} - ${dateFormat(checkoutDateForUI, 'dd mmm yy')}`}</span>
              </li>
            );
          })}
        </S.RecentSearchListWrap>

      </S.RecentSearchInnerWrap>
    </S.RecentSearchOuterWrapper>
  );
};

export default RecentSearchUI;
